import { api } from '../api';
import {
  DEPOSIT_CLAIM_INIT,
  DEPOSIT_CLAIM_POD,
  GET_USER_ADDRESS
} from '../../constants/cryptoDeposit';
import {
  DepositClaimInitRequest,
  DepositClaimInitResponse,
  DepositClaimPODRequest,
  DepositClaimPODResponse,
  GetAddressRequest,
  GetAddressResponse
} from './types';
import { GetBankVSDResponse } from '../fiatDeposit/types';
import {
  STUB_DEPOSIT_ADDRESS,
  stubDelay,
  stubUserAddress
} from './devAddressStub';
import { GET_VSD_BANKS } from '../../constants/fiatDeposit';

export const cryptoDepositSlice = api.injectEndpoints({
  endpoints: (build) => ({
    depositClaimPod: build.mutation<
      DepositClaimPODResponse,
      DepositClaimPODRequest
    >({
      query(data) {
        return {
          url: DEPOSIT_CLAIM_POD,
          method: 'POST',
          body: data
        };
      }
    }),
    depositClaimInit: build.mutation<
      DepositClaimInitResponse,
      DepositClaimInitRequest
    >({
      query(data) {
        return {
          url: DEPOSIT_CLAIM_INIT,
          method: 'POST',
          body: data
        };
      }
    }),
    getUserAddress: build.query<GetAddressResponse, GetAddressRequest>({
      async queryFn(arg, _api, _extraOptions, baseQuery) {
        // Fixture data instead of the call, while corewallet is unreachable on
        // develop. Off unless VITE_STUB_DEPOSIT_ADDRESS says otherwise, and
        // impossible in a production build — see devAddressStub.
        if (STUB_DEPOSIT_ADDRESS) {
          await stubDelay();
          // eslint-disable-next-line no-console
          console.warn(
            '[deposit] serving a STUBBED deposit address — VITE_STUB_DEPOSIT_ADDRESS is on'
          );
          return { data: { data: stubUserAddress(arg) } };
        }

        const result = await baseQuery({
          url: GET_USER_ADDRESS,
          method: 'POST',
          body: arg
        });

        return result.error
          ? { error: result.error }
          : { data: result.data as GetAddressResponse };
      }
    })
  }),
  overrideExisting: false
});

export const {
  useDepositClaimPodMutation,
  useDepositClaimInitMutation,
  useLazyGetUserAddressQuery
} = cryptoDepositSlice;
